import { SiteLayout } from "@varsity/services";
import { TeamEvent, Merchandise } from "../events/events.model";
import { SafeHtml } from "@angular/platform-browser";

export class EventTicketsResponse {
    DisplayPromoFlag?: boolean;
    ImagaName?: string;
    Width?: number;
    Height?: string;
    ImageName?: string;
    Img0_Width?: number;
    Img0_Height?: number;
    Img2_Width?: number;
    Img2_Height?: number;
    Img3_Width?: number;
    Img3_Height?: number;
    JScript?: string;
    StadiumLayoutHtml?: string;
    sections?: Section[];
    curEvent?: any;
    curSeaonsPass?: any;
    EventPromotion?: any;
    VenueURL?: string;
    VenueName?: string;
    VenueID?: number;
    VenueDirectionsURL?: string;
    ContactURL?: string;
    TRCaptchaFlag?: boolean;
    ReDirectURL?: string;
    ResultFlag?: boolean;
    ResultMessage?: string;
    ResultsAvailable?: boolean;
    TrackingID?: number;
    DesktopURL?: string;
    VenueImageUrl?: string;
    VenueWebDescription?: string;
    UnDatedEVent?: number;
    PromosOnlyFlag?: boolean;
    EventID?: number;
    GAVenueOnly?: boolean;
    HasPhotos?: boolean;
    nti: Merchandise[];
    ToolTipDivs?: string;
    ImageMapData?: any;
    PricePoints: PricePoint[];
    sitelayout?: SiteLayout;
    ResultCode?: string;
    MaxHeight?: string; // used on client side
    Special?: string;
    SponsorState?: string;
}

export class Section {
    Color: string;
    DisplayValue: string;
    HandicapSeatsAvailable: number;
    Level: string;
    PhotoFromSection: string;
    PricePoints: any;
    PriceRating: string;
    SeatsAvailable: number;
    SectionName: string;
    SelectedFlag: boolean;
    VenueName: string;
    filterPrices: PricePoint[]
    pricepoint: PricePoint;
}

export class SectionLayout {
    ImageName: string;
    ImagePath: string;
    Width: number;
    Height: number;
    JScript: string;
    SectionLayoutHtml: string | SafeHtml;
    Image: string;
    LastUpdated: string;
    sections: Section[];
    filterPrices: PricePoint[];
    ResultFlag: boolean;
    ResultMessage: string;
}

export class PricePoint {
    DisplayValue?: string;
    PriceRating?: string;
    PriceType?: string;
    PriceCategory?: string;
    Description?: string;
    Price?: string;
    ActualValue?: string;
    DonateValue?: string;
    ReferringUrL?: string;
    MaxWebTickets?: number;
    CCFee?: string;
    PromoCode?: string;
    MinWebTickets?: number;
    IncrWebTickets?: number;
    LongDesc?: string;
    SeatDescription?: string;
    SeatColor?: string;
    Handicapped?: boolean;
    AvaiableCount?: number;
    EventID?: number;
    Count?: number;
    External_Price_Change_ID?: number;
    PricePointID?: number;
    PromoFlag?: boolean;
    OrderQuantity?: number;
    ResultCode?: number;
    Special?: string;
}

export class TransferMethod {
    Name: string;
    Value: string;
    IsSelected?: boolean;
}

export class TransferRecipient {
    FirstName: string = "";
    LastName: string = "";
    Name?: string = "";
    //Phone?: number = null;
    Email?: string = "";
    CustomerID?: number;
    NewCustomer: boolean;
    MobileNumber?: string = null;
}

export class TransferResponse {
    Messages?: string;
    RecentRecipients: TransferRecipient[];
    Recipient?: TransferRecipient;
    Selection?: {
        Events: Event[];
        Sponsors?: any[];
        Tickets: Ticket[]
    }
    TransferType?: string;
    ResultMessage?: string;
    ResultFlag?: boolean;
}

export class Ticket {
    Fees: any;
    Level: string;
    Section: string;
    Row: string;
    Seat: string;
    EventID: number;
    EventDate: string;
    EventTime: string;
    SponsorID: number;
    FaceValue: string;
    TicketDesc: string;
    EventDesc: string;
    HomeTeam: string;
    Opponent: string;
    VenueName: string;
    PriceRating: string;
    PriceType: string;
    PricePointID: number;
    ActualValue: string;
    ActualDisplayValue: string;
    VenueID: number;
    MaxWebTickets: number;
    CCFee: string;
    CCDesc: string;
    CCFeeTaxDesc: string;
    CCFeeTax: string;
    NumRow: number;
    NumSeat: number;
    TicketTaxes: string;
    TicketTaxDesc: string;
    TicketFees: string;
    WebTransFeePerItem: string;
    WebTransFeeMin: string;
    WebTransFeeMax: string;
    WebTransPerOrderFee: number;
    BarMagCode: string;
    SendToPrinter: string;
    NextSeq: number;
    WillCall: number;
    TicketName: string;
    AdImageOnTicket: string;
    EventDetail: string;
    TicketImagePath: string;
    TicketImageType: string;
    BarcodeImagePath: string;
    BarcodeImageType: string;
    Description: string;
    Area: string;
    Results: string;
    Handicapped: number;
    Status: string;
    Reserved: boolean;
    PAHImage: string;
    PAHImageOverride: string;
    PAHMobileImage: string;
    ISOCurrencyCode: string;
    NTI: number;
    NTIQty: number;
    VoucherBarMagCode: string;
    UndatedFlag: boolean;
    CustomForms: {
        FormData: string,
        HTML: string,
        ID: number
    }[];
    ticketformats: any;
    UniqueID: number;
    IsBestAvailable: boolean;
    BestAvailableSection: string;
    DeleteFlag: boolean;
    TicketUsed: number;
    GatesClosedFlag?: boolean;
    EventPassedFlag?: boolean;
    OwnerID?: number;
    GatesOpen?: string;
    TicketAccountActions?: TicketAccountActions;
    showTransferStatus?: boolean = false;
    transferDetailsCheckBox?: boolean = false;
}

export class Package {
    SeasonPassID: number;
    Description: string;
    Price: number;
    Quantity: number;
    QuantityADA: number;
    ActualValue: number;
    Charge: number;
    CCFee: number;
    CCFeeTax: number;
    BOCCFee: number;
    BOCCFeeTax: number;
    PriceRating: number;
    PriceType: string;
    StartSellingDate: string;
    EndSellingDate: string;
    ProRate: number;
    ServerDate: string;
    Price2: number;
    ReferringURL: string = "";
    UnDated: number;
    MinPackages: number;
    MaxPackges: number;
    MinTickets: number;
    MaxTickets: number;
    IncrPackages: number;
    CreateCodedCard: boolean;
    PrintOneTicket: boolean;
    NewRenewSales: boolean;
    Category: string;
    WebDescription: string = "";
    ListOrder: string;
    SponsorID: number;
    VenueName: string;
    VenueID: number;
    HeadingText: string = "";
    AboutText: string = null;
    SeasonPassImage: string = null;
    FlexPlan: boolean;
    MiniSeasonPassID: number;
    EventIDs: string;
    NameOnTicket: string = null
    PackageID: number;
    ReClassIDs: string = null;
    TempProCode: string = null;
    ResultFlag: boolean;
    ResultMessage: string = null;
    ReserveTimeout: number;
    sections: any[];
    tickets: SelectableTicket[];
    sponsor: string = null
    flexplanevents: string[] = [];
    ticketformats: TicketFormat[];
    selected?: boolean = false;
}

export class PackageWithGroupedTickets extends Package {
    groupedTickets: any;
}

export class CommonTicketItem {
    Level?: string;
    Section?: string;
    Row?: string;
    Seat?: string;
    Description: string;
    ActualValue: string;
    EventID?: number;
    VenueName: string;
    SeasonPassID?: number;
    Quantity?: number;
    DeleteFlag?: boolean;
    Levels?: string[];
    Sections?: string[];
    Rows?: string[];
    Seats?: string[];
    CustomForms: {
        FormData: string,
        HTML: string,
        HTML_Sanitized?: SafeHtml;
        ID: number
    }[] | {
        FormData: string,
        HTML: string,
        HTML_Sanitized?: SafeHtml;
        ID: number
    }[][];
    Id?: string;
}


export class SelectableTicket extends Ticket {
    IsSelected: boolean;
}

export class DisplayTicket extends Ticket {
    viewImagePath: string;
    viewTicketDesc: string;
}

export class StadiumTicket extends Ticket {
    irow: number;
    iseat: number;
    PricePoint: PricePoint;
    currentSelection: boolean;
    DisplayValue: string;
}

export class PerOrderFee {
    Description: string;
    Amount: string;
    TaxDescription: string;
    TaxAmount: string;
    PerOrderFeeTaxID: number | null;
}

export class TicketFormat {
    ID: number;
    Description: string;
    SelectedFlag: boolean;
}

export class Fulfillments {
    FulfillmentID: number;
    ShortName: string;
    WebDescription: string;
    ReceiptDescription: string;
    Charge: string;
    SelectedFlag: boolean;
    fulfillmentTax: string;
    ticketformats: any;

}

export class Confirmation {
    tickets: Ticket[];
    feetotals: any[]
    fulfillments: Fulfillments[];
    lstPerOrderFees: any;
    SeasonPassShows: any;
    seasonpasses: Package[];
    nti: Merchandise[];
    SelectedSection: string
    NTITaxTotal: string;
    NTITotal: string;
    NTICCTotal: string;
    NTICCTaxTotal: string;
    NTICCTaxDesc: string;
    SubTotal: string;
    CCDesc: string;
    CCTotal: string;
    CCTaxTotal: string;
    CCTaxDesc: string;
    DiscountTotal: string;
    TaxesTotal: string;
    FeesTotal: string;
    TransactionTotal: string;
    ISOCurrencyCode: string;
    Results: number;
    ResultsDescription: string;
    PurchaseToken: string;
    pcipay: any;
    SeasonPassFlag: boolean;
    FieldMuseumFlag: boolean;
    DiscountDescription: string;
    DiscountInfo: string;
    DiscountFlag: boolean;
    VoucherFlag: boolean;
    VoucherList: any;
    VoucherAmtList: string;
    VoucherTotal: string;
    PCIPayFlag: boolean;
    PromoFlag: boolean;
    insurance?: { nti: Merchandise };
    InsuranceMessage: string;
    DBName: string;
    ReserveTimeout: number;
    ReserveTimeoutLocal?: string;
    perOrderFee: {
        Amount: string
        Description: string
        PerOrderFeeTaxID?: number
        SponsorID: number
        TaxAmount: string
        TaxDescription: string
    };
    QuoteID?: number;
    QuoteAmount?: number;
    QuoteToken?: string;
    WidgetQuoteToken?: string;
    CustomForms?: {
        FormData: string,
        HTML: string,
        ID: number,
        HTML_Sanitized?: SafeHtml;
    }[];
}

export class Receipt {
    BarcodedNTI: string;
    CCAuthorization: string;
    CCBillText: string;
    CCDesc: string;
    CCTaxDesc: string;
    CCTaxTotal: string;
    CCTotal: string;
    ConfirmationID: number;
    DiscountTotal: string;
    Fees: any;
    ISOCurrencyCode: string;
    InsuranceFlag: boolean;
    InsuranceMessage: string;
    NTITaxTotal: string;
    NTITotal: string;
    SubTotal: string;
    TicketsTotal: string;
    TransactionDate: string;
    TransactionTotal: string;
    VoucherTotal: string;
    events: TeamEvent[];
    feetotals: any[]
    fulfillments: Fulfillments[];
    nti: Merchandise[];
    perOrderFee: any;
    tickets: Ticket[];
}

export class CustomerReceipt {
    ConfirmationID: number;
    TransactionDate: string;
    SponsorID: number;
    NumTickets: number;
    TransactionTotal: string;
    DisplayFlag?: boolean;
}

export class PurchaseConfirmation {
    AccountCreatedFlag: boolean;
    AppleWalletData: string;
    ConfirmationID: number;
    CustomerID: number;
    DisplayMobileFlag: boolean;
    EmailAddress: string;
    FreeFormLine1: string;
    FreeFormLine2: string;
    HoldID: number;
    Message: string;
    PhoneNumber: string;
    SuccessFlag: boolean;
    TempPwd: string;
    TicketFGL: string;
    UserDirection: string;
    addOnEvents: any;
    tickets: SelectableTicket[];
    nti: Merchandise[];
    seasonpasses: Package[];
}

export class DirectLinkTickets {
    Selection: Ticket[];
    Tickets: Ticket[];
    siteLayout: SiteLayout;
    ResultFlag: boolean;
    ResultMessage: string;
}

export class TicketAccountActions {
    ShowTransfer?: boolean;
    ShowPrint?: boolean;
    ShowGateValidate?: boolean;
    ShowText?: boolean;
    ShowMobile?: boolean;
}



// WEBPACK FOOTER //
// ./src/services/tickets/tickets.model.ts